import http, {Service} from './common'
class TemplateService extends Service {
  async getShippingFormEms() {
    return http.get(`/${this.resource}/formems`).then(res => res.data);
  }
}

export default new TemplateService("template")
